import { Card } from "react-bootstrap";
import "../supplier-info.scss";

const InfoSection = ({ title, children, className = "" }) => (
    <Card className={`mb-3 ${className}`}>
        {title && (
            <Card.Header className="fw-bold bg-light is-header-sm">
                {title}
            </Card.Header>
        )}
        <Card.Body className="py-2">{children}</Card.Body>
    </Card>
);

export default InfoSection;
